<div class="quick-navigator">
    @if (isMasterproject){
       <button [disabled]="isNavigatorDisabled" class="grid-icon" class="multi-release-mode" [ngClass]="{
         'multi-release-mode-pinned': projectinfo?.pinStatus && !isPinnedSection,
         'unpinned-projects-aig-pmo': !isPinnedSection && projectinfo?.pinStatus && (projectinfo?.PMOProject || projectinfo?.AIGProject),
         'multi-release-mode-pinned-aig-pmo': !isPinnedSection && (projectinfo?.PMOProject || projectinfo?.AIGProject),
         'multi-release-mode-pinned-section': isPinnedSection && (projectinfo?.PMOProject || projectinfo?.AIGProject)
       }" mat-icon-button [matMenuTriggerFor]="menu" (click)="openQuickNavigator()" [style.top.px]="theme === 'light' ? (VIEW === VIEW_TYPE.GRID_VIEW ? -4 : -11) : null">
                  <mat-icon class="more-vert-icon">more_vert</mat-icon>
        </button>
    }
    @else if (releaseView && (releaseInfo?.isPSGCompleted === 'Y' || releaseInfo?.isPSGCompleted === undefined)){
        <button class="grid-icon" class="multi-release-mode multi-release-mode-release-view"  mat-icon-button [matMenuTriggerFor]="menu" (click)="openQuickNavigator()" [style.top.px]="theme === 'light' ? (VIEW === VIEW_TYPE.GRID_VIEW ? -4 : -11) : null">
            <img class="release-view-location-icon" src="/assets/my-projects/location_icon.svg" alt="release view icon">
        </button>
    }
    @else if (!releaseView) {
    <button class="grid-icon" [ngClass] ="theme=== defaultTheme ? 'dark-theme' : 'light-theme'" mat-icon-button [matMenuTriggerFor]="menu" (click)="openQuickNavigator()" [style.top.px]="theme === 'light' ? (VIEW === VIEW_TYPE.GRID_VIEW ? -4 : -11) : null">
    </button>
    }
    <mat-menu #menu="matMenu" yPosition="below" xPosition="before" [style.position]="'absolute'" [style.left.px]="0"
        [style.top.px]="0">
        <div *ngFor="let screen of screenOptions; trackBy: trackByScreen">
            <button
                class="mat-menu-item" [ngClass]="{'current-screen': currentScreenName === screen.name, 'master-special-item': masterProjectSpecialStyling}" mat-menu-item
                (click)="currentScreenName === screen.name ? $event.stopPropagation() : goto(screen?.name, screen?.path)">
                <span *ngIf="!masterProjectSpecialStyling"><img id="icon" src="/assets/navigator-default.svg"></span><span>{{screen.translatedName | translate}}</span>
            </button>
        </div>
        <hr *ngIf="masterProjectSpecialStyling">
        <button class="mat-menu-item" (click)="goToUsersPage('users', projectinfo, 'PROJECT')"
            *ngIf=" masterProjectSpecialStyling && !userPermissionObj?.isExternalUser && userPermissionService.canUserAccessObject(ACCESS_OBJECTS.PROJECT, OBJECT_VALUES.MANAGE_USER, PERMISSIONS.ALL, projectinfo)"
            mat-menu-item>
            <span>{{"ListProject.Menu.ManageUsers" | translate}}</span>
        </button>

         <button class="mat-menu-item" mat-menu-item
            *ngIf="masterProjectSpecialStyling && !userPermissionObj?.isExternalUser && projectinfo?.projectStatus !== PROJECT_STATUS.PENDING_APPROVAL
                    && isCurrentUserAdmin
                    && userPermissionService.canUserAccessObject(ACCESS_OBJECTS.PROJECT, OBJECT_VALUES.PROJECT, PERMISSIONS.DELETE, projectinfo)"
            (click)="openRestrictedDeleteDialog(projectinfo,'PROJECT')">
            <span>{{"ListProject.Menu.DeleteProject" | translate}}</span>
          </button>
       <button class="mat-menu-item" mat-menu-item
                    *ngIf="resetDraftFeatureflag && masterProjectSpecialStyling && !userPermissionObj?.isExternalUser && projectinfo?.projectStatus === PROJECT_STATUS.DRAFT
                    && userPermissionService.canUserAccessObject(ACCESS_OBJECTS.PROJECT, OBJECT_VALUES.EDIT_PROJECT, PERMISSIONS.ALL, projectinfo)"
                    (click)="goToCreateProjectsPage()">
                    <span>{{"MyProject.Map.EditProject.Text" | translate}}</span>
        </button>
    </mat-menu>

</div>